<template>
    <!-- IE 2026 10 25 / ODOO-348925 (заказ Игоря: вкладка «Граф зв’язків» схемы PLAN-MAP-SET v3): тонкая обёртка над штатным AttrGraph (вид «Каскад розрахунку»).
         Обёртка строит данные графа из doc.nodes / doc.edges документа в _doc.<имя> (только FE: запись не метит, на бэк не уходит) и отдаёт их AttrGraph
         с ТЕМ ЖЕ attr_id; собственных подсказок по наведению нет — объяснения по Alt / Show tooltips даёт сам AttrGraph. Выключатель fe.ux.schemeGraph (дефолт ВКЛ;
         выкл — пустая вкладка, как на старом фронте). -->
    <!-- IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы, взаимное выделение, виды связей): fe.ux.schemeGraphV2 (дефолт ВКЛ) — граф v2 на SVG-движке переходов; выкл — прежний v1 ниже -->
    <AttrSchemeGraphV2 v-if="attr && v2" :widget_id="widget_id" :attr_id="attr_id" />
    <div v-else-if="attr && on" class="sg-wrap">
        <div v-if="notice" class="sg-notice">{{ notice }}</div>
        <template v-else>
            <div v-if="warn" class="sg-warn">{{ warn }}</div>
            <AttrGraph v-if="ready" ref="graph" :widget_id="widget_id" :attr_id="attr_id" />
        </template>
    </div>
</template>

<script>
// ---------------------------------------------------------------------------
// AttrSchemeGraph — граф связей схемы: узлы — листья табличной части nodes_binding (иерархия вложенностью children_path, группы — прямоугольники),
// связи — строки edges_binding (концы — edges_source_binding / edges_target_binding, ключ узла — key_binding). Сборка и раскладка — utils/schemeGraph.js
// (dagre, как graphLayoutStd), отрисовка, клик по узлу / связи / группе (карточка строки), двойной клик (запись элемента системы), шестерёнка — штатный AttrGraph.
// Граф ничего не пишет в документ. Правка узлов / связей на соседних вкладках — $watch подписи → пересборка; та же раскладка — AttrGraph обновляет подписи
// и цвета точечно (tryPatchGraph). Счётчики проб — window.__sgStats.
// ---------------------------------------------------------------------------
import { toRaw } from 'vue'
import { useMainStore } from '@/stores/mainStore'
import { t } from '@/i18n'
import { schemeGraphOn, sgConfig, buildSchemeGraph, structSig, warnDangling } from '@/utils/schemeGraph'   // IE 2026 10 25 / ODOO-348925
import { schemeGraphTitleClearOn } from '@/utils/schemeGraph'   // IE 2026 10 25 / ODOO-348925: выключатель fe.ux.schemeGraphTitleClear
import { schemeGraphTitleRoomOn, schemeGraphEdgeLabelsOn } from '@/utils/schemeGraph'   // IE 2026 10 25 / ODOO-348925: выключатели fe.ux.schemeGraphTitleRoom, fe.ux.schemeGraphEdgeLabels
import { schemeGraphEdgeLabelHideOn } from '@/utils/schemeGraph'   // IE 2026 10 25 / ODOO-348925: выключатель fe.ux.schemeGraphEdgeLabelHide
import { schemeGraphV2On } from '@/utils/schemeGraphV2'   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы, взаимное выделение, виды связей): выключатель fe.ux.schemeGraphV2
import AttrSchemeGraphV2 from './AttrSchemeGraphV2.vue'   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы, взаимное выделение, виды связей)

function stats() {
    if (typeof window === 'undefined') return {}
    return (window.__sgStats = window.__sgStats || { builds: 0, layouts: 0, skipped: 0, ms: 0, nodes: 0, edges: 0, dangling: 0, loops: 0 })
}

export default {
    name: 'AttrSchemeGraph',
    components: { AttrSchemeGraphV2 },   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы, взаимное выделение, виды связей)
    props: {
        widget_id: [String, Number],
        attr_id: String,
    },
    data: () => ({
        WIDGET: {},
        attr: null,
        parent_attr: null,
        on: true,       // fe.ux.schemeGraph
        notice: '',     // не настроено / нет узлов — вместо графа
        warn: '',       // висячие связи, дубли ключей — над графом
        ready: false,   // данные графа собраны — можно монтировать AttrGraph
        v2: false,      // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы, взаимное выделение, виды связей): fe.ux.schemeGraphV2 — граф рисует AttrSchemeGraphV2 (SVG), AttrGraph не монтируется
    }),
    setup() {
        const store = useMainStore()
        return { store }
    },
    created() {
        // не реактивные поля: кэш раскладки, последний собранный объект, подписи
        this._cache = {}; this._built = null; this._sig = ''; this._warnSig = ''
        this.WIDGET = this.store.findWidget(this.widget_id).WIDGET
        // attr — по тому же id, но БЕЗ реестра attrs_vueObj: там регистрируется вложенный AttrGraph (рассылка content_Changed, шестерёнка, легенда — его)
        this.store.widget_attr_set(this, false)
        this.v2 = schemeGraphOn((k, d) => this.setting(k, d)) && schemeGraphV2On((k, d) => this.setting(k, d))   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы, взаимное выделение, виды связей)
        this.sync()
        // узлы / связи изменились на другой вкладке; запись заменилась (ответ бэка выбрасывает _doc) — пересобрать
        this.$watch(() => this.watchSig(), (n, o) => { if (n !== o) this.sync() })
    },
    methods: {
        setting(k, d) { return this.store.setting(k, d) },
        sources(cfg) {
            const rec = this.WIDGET?.record
            const nodes = rec ? this.store.get_value(rec, cfg.nodes_binding) : null
            const edges = rec ? this.store.get_value(rec, cfg.edges_binding) : null
            return { nodes: Array.isArray(nodes) ? nodes : [], edges: Array.isArray(edges) ? edges : [] }
        },
        binding() {
            const b = String(this.attr?.binding || '')
            return b.startsWith('_doc.') && b.length > 5 ? b : ''
        },
        // подпись для $watch: состав узлов и связей + «собранный объект на месте»
        watchSig() {
            if (this.v2) return 'v2'   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы, взаимное выделение, виды связей): v2 следит за данными сам
            if (!this.attr || !this.WIDGET?.record || !schemeGraphOn((k, d) => this.setting(k, d))) return 'off'
            const { cfg, errors } = sgConfig(this.attr)
            if (errors.length) return 'cfg'
            const s = this.sources(cfg)
            const b = this.binding()
            const mine = b && this._built !== null && toRaw(this.store.get_value(this.WIDGET.record, b)) === this._built
            return `${mine ? 1 : 0}|${structSig(s.nodes, s.edges, cfg, this.store.get_lang())}`
        },
        sync() {
            if (!this.attr || !this.WIDGET?.record) return
            if (this.v2) { this.drop(); return }   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы, взаимное выделение, виды связей): v2 рисует сам — data_graph для AttrGraph не строится
            const store = this.store
            this.on = schemeGraphOn((k, d) => this.setting(k, d))
            if (!this.on) { this.drop(); return }
            const { cfg, errors } = sgConfig(this.attr)
            const missing = errors.find((e) => e.code === 'missing')
            if (missing) { this.drop(); this.notice = t('The graph is not configured: {params} missing', { params: missing.params.join(', ') }); return }
            const b = this.binding()
            if (!b) { this.drop(); this.notice = t('The graph is not configured: binding must start with "_doc."'); return }
            const src = this.sources(cfg)
            if (!src.nodes.length) { this.drop(); this.notice = t('No nodes: the table part {binding} is empty', { binding: cfg.nodes_binding }); return }
            const lang = store.get_lang()
            const sig = structSig(src.nodes, src.edges, cfg, lang)
            const S = stats()
            if (this.ready && sig === this._sig && this._built && toRaw(store.get_value(this.WIDGET.record, b)) === this._built) { S.skipped++; return }   // ничего не изменилось
            const T0 = performance.now()
            let res
            try {
                res = buildSchemeGraph(src.nodes, src.edges, cfg, lang, { cache: this._cache, warn: (...a) => console.warn(...a),
                    titleClear: schemeGraphTitleClearOn((k, d) => this.setting(k, d)),   // IE 2026 10 25 / ODOO-348925: подписи узлов обходят заголовок группы
                    titleRoom: schemeGraphTitleRoomOn((k, d) => this.setting(k, d)), edgeLabels: schemeGraphEdgeLabelsOn((k, d) => this.setting(k, d)),
                    edgeLabelHide: schemeGraphEdgeLabelHideOn((k, d) => this.setting(k, d)) })   // IE 2026 10 25 / ODOO-348925: подпись связи с наложением на этом масштабе не рисуется   // IE 2026 10 25 / ODOO-348925: запас под заголовок (экранные px), подписи связей без наложений
            } catch (e) {
                console.warn('[AttrSchemeGraph] the graph is not built', e)
                this.drop(); this.notice = t('The graph cannot be built: {error}', { error: e?.message || String(e) }); return
            }
            this._warnSig = warnDangling(res.dangling, this._warnSig)
            this.warn = this.warnText(res)
            this._sig = sig
            this._built = res.data_graph
            this.notice = ''
            store.set_value(this.WIDGET.record, b, res.data_graph, null, null, null, false)   // _doc — служебная область: запись не метится изменённой
            this._built = toRaw(store.get_value(this.WIDGET.record, b))
            S.builds++; if (res.stats.relaid) S.layouts++
            S.ms = Math.round(performance.now() - T0); S.nodes = res.stats.nodes; S.edges = res.stats.edges; S.dangling = res.stats.dangling; S.loops = res.stats.loops
            if (!this.ready) { this.ready = true; return }   // AttrGraph смонтируется и сам прочтёт данные (content_Changed в created)
            const g = this.$refs.graph
            if (g && typeof g.content_Changed === 'function') g.content_Changed()
        },
        drop() {
            this.ready = false; this.warn = ''; this._built = null; this._sig = ''
        },
        warnText(res) {
            const parts = []
            const missing = res.dangling.filter((d) => d.reason !== 'group').length, toGroup = res.dangling.length - missing
            if (missing) parts.push(t('{n} links refer to nodes that are not in the scheme', { n: missing }))
            if (toGroup) parts.push(t('{n} links refer to a group, not a node', { n: toGroup }))
            if (res.dupKeys.length) parts.push(t('Duplicate node key "{key}": links go to the first node', { key: [...new Set(res.dupKeys)].join(', ') }))
            return parts.join(' · ')
        },
    },
}
</script>

<style>
/* IE 2026 10 25 / ODOO-348925: размер ведёт вложенный AttrGraph (высота — до низа виджета); здесь только поля и текст сообщений */
.sg-wrap { width: 100%; }
.sg-notice, .sg-warn { padding: 8px 12px; color: var(--text-color-secondary, #6b7280); }
.sg-warn { font-size: 0.9em; padding: 4px 12px; }
</style>
